(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-template"]) return;
  try {
    
/*
    $('.btn-plus-cart').click(function(){
      var max = parseInt($('.quantity__input').attr('max'));
      var quantity = parseInt($('.quantity__input').val());
      if(quantity != max) {
        quantity = quantity + 1;
      }
      $('.quantity__input').val(quantity);      
    });

    $('.btn-minus-cart').click(function(){
      var quantity = parseInt($('.quantity__input').val());
      if(quantity != 1) {
        quantity = quantity - 1;
      }
      $('.quantity__input').val(quantity);      
    })
*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    

    if($('.pdps-hero').attr('data-product-type') == 'single') {
      $('.header-wrapper').addClass('_pdps');

      $('.pdps-hero').appendTo('.header-wrapper');

    }
    

  } catch(e) { console.error(e); }
})();
})();
